export default "__VITE_ASSET__7FFBqjNX__"